import { useState, useEffect } from 'react';
import { PetPhoto } from '../../types/PetPhoto';
import { validateImageUrl } from '../../utilities';

interface UsePhotoValidationResult {
  validPhotos: PetPhoto[];
  isValidating: boolean;
}

function usePhotoValidation(photos: PetPhoto[]): UsePhotoValidationResult {
  const [validPhotos, setValidPhotos] = useState<PetPhoto[]>([]);
  const [isValidating, setIsValidating] = useState(false);

  useEffect(() => {
    const validatePhotos = async () => {
      setIsValidating(true);
      const validPhotosArray: PetPhoto[] = [];

      const validationPromises = photos.map(async (photo) => {
        const isValid = await validateImageUrl(photo.url);
        return { photo, isValid };
      });

      const results = await Promise.all(validationPromises);

      results.forEach(({ photo, isValid }) => {
        if (isValid) {
          validPhotosArray.push(photo);
        }
      });

      setValidPhotos(validPhotosArray);
      setIsValidating(false);
    };

    if (photos.length > 0) {
      validatePhotos();
    } else {
      setValidPhotos([]);
      setIsValidating(false);
    }
  }, [photos]);

  return { validPhotos, isValidating };
}

export default usePhotoValidation;
